import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import React, { } from "react";
import { isNullEmpty } from "../../../utils/validation";

const UsingSellingPriceSelect = ({ value, error, onChangeValue, ...props }) => {
  return (
    <FormControl {...props}>
      <Select
        value={value}
        sx={{ width: 200 }}
        onChange={(e) => onChangeValue(e.target.value)}
        error={!isNullEmpty(error)}
        //onFocus={ () => validate.handleTouch("isUsingSellingPrice")}
      >
        <MenuItem value={true}>
          表示する
        </MenuItem>
        <MenuItem value={false}>
          表示しない
        </MenuItem>
      </Select>
      {!isNullEmpty(error) && (
        <FormHelperText sx={{color:"#d32f2f"}}>{error}</FormHelperText>
      )}
    </FormControl>
  );
}
export default UsingSellingPriceSelect;
